/*!
 * @author electricessence / https://github.com/electricessence/
 * Licensing: MIT https://github.com/electricessence/TypeScript.NET/blob/master/LICENSE.md
 * Based upon: https://msdn.microsoft.com/en-us/library/System.Exception%28v=vs.110%29.aspx
 */
define(["require", "exports", "./SystemException", "../../extends"], function (require, exports, SystemException_1, extends_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    // noinspection JSUnusedLocalSymbols
    var __extends = extends_1.default;
    var NAME = 'NullReferenceException';
    var NullReferenceException = /** @class */ (function (_super) {
        __extends(NullReferenceException, _super);
        function NullReferenceException() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        NullReferenceException.prototype.getName = function () {
            return NAME;
        };
        return NullReferenceException;
    }(SystemException_1.SystemException));
    exports.default = NullReferenceException;
});
